/**
 * @file automatically generated from MApp.Data.SpatialOperation
 */

export enum SpatialOperation {
    None = 0,
    Intersects = 1,
    Contains = 2,
    Aggregate = 3,
    NumVertices = 4,
    Envelope = 5,
    Filter = 6
}
